import React, { useEffect, useRef, useState } from "react";
import Header from "../_components/common/Header";
import "../_css/TeacherManagement.css";
import AddTeacher from "../_components/UI/AddTeacher";
import UpdateTeacher from "../_components/UI/UpdateTeacher";
import { blockTeacher, getTeacherList } from "../requests";
import { formatDateLong } from "../_components/helper/formatters";
import { deleteAuthToken, notifyError, notifySuccess } from "../utils/helper";
import { useNavigate } from "react-router-dom";
import SearchableDropdown from "../_components/common/SearchableDropdown";
import { useDispatch } from "react-redux";
import { startLoader } from "../_store/reducers/loaderReducer";
import { stopLoader } from "../_store/reducers/loaderReducer";
import { addExcelTeachers } from "../requests";
import AddExcelModal from "../_components/Modals/AddExcelModal";

const TeacherManagement = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  const [readOnly, setReadOnly] = useState(false);


  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  
  const navigate = useNavigate()

  const [addTeacher, setAddTeacher] = useState(false);
  const [updateTeacher, setUpdateTeacher] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [option, setIsOption] = useState(false);
  const [teacherList, setTeacherList] = useState([]);
  const [teacherData, setTeacherData] = useState(null);
  const [filterData, setFilterData] = useState({
    name: "",
    grade: "",
    subject: "",
  });

  const [openAddExcelModal, setOpenAddExcelModal] = useState(false);




  const getAllTeachers = async (pageVal) => {

    if(filterData.grade == 'All classes') filterData.grade = ''
    if(filterData.subject == 'All subjects') filterData.subject = ''

    dispatch(startLoader())

    try {
      const response = await getTeacherList({page: pageVal, limit: limit, ...filterData});
      setTeacherList(response.data.data);
      setTotalCount(response.data.totalCount);

    } catch (error) {
      if(error?.response?.status == 403){
        notifyError(error?.response?.data?.error ||"Your session has expired. Please log in again.")
        deleteAuthToken()
        navigate('/login')
        return;
      }
      notifyError(error?.response?.data?.error || "Something went wrong");
      console.log(error);
    } finally {
      dispatch(stopLoader())
    }
  };

  const block_Teacher = async (el) => {
    try {
      const isBlock = el.account_status == 2 ? false : true;
      const res = await blockTeacher(el.id, { block: isBlock });

      notifySuccess(res?.data?.message);
      setRefresh(!refresh);
    } catch (error) {

      if(error?.response?.status == 403){
        notifyError(error?.response?.data?.error ||"Session Time out log in again")
        deleteAuthToken()
        navigate('/login')
        return;
      }
      

      notifyError("Failed to block teacher");
    }
  };

  const handleClick = async (e, el) => {
    console.log("el:",el);
    if(e == '3'){
      setUpdateTeacher(true);
      setIsOption(!option);
      setReadOnly(true);
      setTeacherData(el);
      
    }
    else if (e == '1') {
      setReadOnly(false);
      setUpdateTeacher(true);
      setTeacherData(el);
      setIsOption(!option);
    } else {
      setIsOption(!option);
      await block_Teacher(el);
    }
  };

  const timeoutRef = useRef(null);

  useEffect(() => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a new timeout to call the API after 1.5 seconds
    timeoutRef.current = setTimeout(() => {
      setPage(1);
      getAllTeachers(1);
    }, 1500);

    // Cleanup function to clear timeout on unmount or when filterData changes again
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [filterData]);

  useEffect(() => {
    getAllTeachers(page);
  }, [addTeacher, updateTeacher,refresh,page]);

   const subjects = [
    "All subjects",
  "Mathematics",
  "English",
  "Science",
  "History",
  "Geography",
  "Physics",
  "Chemistry",
  "Biology",
  "Computer Science",
  "Information Technology",
  "Environmental Science",
  "Political Science",
  "Economics",
  "Business Studies",
  "Accountancy",
  "Sociology",
  "Psychology",
  "Philosophy",
  "Civics",
  "Literature",
  "Grammar",
  "Statistics",
  "Engineering Drawing (Theory)",
  "Design and Technology (Theory)",
  "Astronomy",
  "Geology",
  "Anthropology",
  "Archaeology",
  "Law",
  "Media Studies",
  "Communication Skills (Theory)",
  "Entrepreneurship",
  "Marketing",
  "Tourism and Hospitality (Theory)",
  "Fashion Studies (Theory)",
  "Agriculture (Theory)",
  "Computer Applications",
  "Applied Mathematics",
  "Modern History",
  "World History",
  "Ancient History",
  "Political Theory",
  "International Relations",
  "Public Administration",
  "Linguistics",
  "Environmental Studies",
  "Current Affairs",
  "General Knowledge",
  "Moral Science"
];


  const classes = ["All classes",1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  
  return (
    <div className='page-main' onMouseDown={()=>setOpen(false)}>
      <Header name={["Teacher Management"]} />
      {openAddExcelModal && <AddExcelModal onClose={()=>setOpenAddExcelModal(false)} />}

      <div className="teacher-container">
        <div className="teacher-head">
          <div className="teacher-head-text">Teacher Management</div>
          <div className="teacher-head-right">
            <SearchableDropdown  options ={[...subjects]} selected={filterData.subject} setSelected={(e)=>setFilterData((prev)=>({...prev, subject:e}))}  color = '#E5E7EB'/>
             <SearchableDropdown  options ={[...classes]} selected={filterData.grade} setSelected={(e)=>setFilterData((prev)=>({...prev, grade:e}))}  color = '#E5E7EB' allowManualEntry = {false}/>

            <input
              value={filterData.name}
              
              placeholder="Search name"
              className="teacher-head-search"
              onChange={(e) =>
                setFilterData({ ...filterData, name: e.target.value })
              }
            />
            <button
              onClick={() => setAddTeacher(true)}
              className="teacher-head-add"
            >
              Add
            </button>


            <button
              onClick={() => setOpenAddExcelModal(true)}
              className="teacher-head-add"
            >
              Upload CSV
            </button>
          </div>
        </div>
        <div className="teacher-table" style={{ borderTop: "none" }}>
          <div className="teacher-table-head">
            <div className="teacher-table-head-cell" style={{ width: "20%" }}>
              Teacher Name
            </div>
           
            <div className="teacher-table-head-cell" style={{width: "20%"}}>Class</div>
            <div className="teacher-table-head-cell" style={{width: "30%"}}>School</div>
            <div className="teacher-table-head-cell" style={{width: "20%"}}>Uploaded On</div>
            <div className="teacher-table-head-cell" style={{ width: "10%" ,textAlign: "center"}}>
              Actions
            </div>
          </div>

          {teacherList.length > 0 &&
            teacherList.map((el,i) => (
              <div key={i} className="teacher-table-row"  style={{borderBottom: i == teacherList.length - 1&& 'none'}}>
                <div
                  className="teacher-table-row-cell"
                  style={{ width: "20%" }}
                >
                  {el.name}
                </div>
               
                <div className="teacher-table-row-cell" style={{width: "20%"}}>{el.grade || "-"}</div>
                <div className="teacher-table-row-cell" style={{width: "30%"}}>
                  {el.school || "-"}
                </div>
                <div className="teacher-table-row-cell" style={{width: "20%"}}>
                  {formatDateLong(el.created_at)}
                </div>
                 <div className="dropdown"  style={{width: "10%",textAlign: "center"}}>
      {/* Trigger Button */}
      <button onClick={() => setOpen(el.id)} className="dropdown-btn">
        ⋮
      </button>

      {/* Dropdown Menu */}
      {open == el.id && (
        <div
         className="dropdown-content">

           {/* View */}
           <div className="option" onMouseDown={()=>handleClick('3',el)}>
           <img src='/eye-empty.svg' alt="view" style={{width: "16px",height: "16px", marginRight: "8px"}}/>
            View
          </div>
          {/* Edit */}
          <div className="option" onMouseDown={()=>handleClick('1',el)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="drp-icon"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.862 4.487l1.687 1.687m-2.79-2.79l-9.193 9.193a4.5 4.5 0 00-1.126 2.012l-.376 1.502a.75.75 0 00.94.94l1.502-.376a4.5 4.5 0 002.012-1.126l9.193-9.193m0 0l-1.687-1.687"
              />
            </svg>
            Edit
          </div>

          {/* Block */}
          <div  className="option" onMouseDown={()=>handleClick('2',el)} >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="drp-icon red"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18.364 5.636a9 9 0 11-12.728 12.728A9 9 0 0118.364 5.636zM8.464 8.464l7.072 7.072"
              />
            </svg>
            {el.account_status == 2 ? "UnBlock" : "Block"}
          </div>
        </div>
      )}
    </div>
                {/* <select
                  key={option}
                  className="teacher-table-row-cell "
                  defaultValue="⋮"
                  onClick={(e) => handleClick(e, el)}
                  style={{
                    width: "71px",
                    textAlign: "center",
                    cursor: "pointer",
                    appearance: "none",
                    border: "none",
                    background: "transparent",
                  

                  }}
                >
                  <option value="" hidden>
                    {" "}
                    &#8942;
                  </option>
                  <option  value="1">Edit</option>
                  <option  value="2">
                    {el.account_status == 2 ? "UnBlock" : "Block"}
                  </option>
                </select> */}
              </div>
            ))}
        </div>
        <div className="di-flex" style = {{width: '100%'}}>
          <div style={{ color: "#6B7280" }}>
            {" "}
            Showing {((page-1) * limit )+ 1} to {teacherList.length + (page - 1) * limit} out of {totalCount}{" "}
            items{" "}
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page == 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page == 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={teacherList.length + (page - 1) * limit >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  teacherList.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (teacherList.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>


       
        
      </div>

      {addTeacher && <AddTeacher fn={() => setAddTeacher(false)} />}

      {updateTeacher && (
        <UpdateTeacher fn={() => setUpdateTeacher(false)} data={teacherData}  readOnly={readOnly}/>
      )}
    </div>
  );
};

export default TeacherManagement;
